import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./Invoice_Details.css";
import { Header } from "../../components/Header/Header";
import LineItems from "./LineItems";
import Cookies from "js-cookie";
import api from "../chat/api";
import ReminderDropdown from "./ReminderDropdown";
import { toast } from "../../utils/appToast";

function Invoice_Details({ isMenuOpen }) {
  const location = useLocation();
  const { extractedData } = location.state || {};
  const { invoiceKey } = useParams();
  const handleGoToInvoices = () => {
    navigate("/Invoices");
  };

  const [isHovered, setIsHovered] = useState(false);

  const [contractData, setContractData] = useState(null);
  const [contractId, setContractId] = useState(null);
  const [contractKey, setContractKey] = useState(null);
  const [editingCustomField, setEditingCustomField] = useState(null);
  const hiddenInputRef = useRef(null);
  const [note, setNote] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [activeEditField, setActiveEditField] = useState(null);
  const [userNote, setUserNote] = useState("");
  const [isButtonVisible, setButtonVisible] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const notesRef = useRef(null);
  const [isEditingNote, setIsEditingNote] = useState(false);
  const [fieldName, setFieldName] = useState("");
  const [fieldPrompt, setFieldPrompt] = useState("");
  const isFilled = fieldName.trim() !== "" && fieldPrompt.trim() !== "";
  const [loadingAddField, setLoadingAddField] = useState(false);
  const [customFields, setCustomFields] = useState([]);
  const [customFieldsLoading, setCustomFieldsLoading] = useState(false);

  const [selectedTab, setSelectedTab] = useState("create"); // 'create' or 'manage'

  const [deletingField, setDeletingField] = useState(null);

  const [invoicesId, setInvoicesId] = useState(null);
  const [openSections, setOpenSections] = useState({
    termsAndConditions: false,
    financialTerms: false,
    legalClauses: false,
  });
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [isKeyDatesOpen, setIsKeyDatesOpen] = useState(false);
  const editRef = useRef(null);
  const [edit, setEdit] = useState(false);
  const [editedData, setEditedData] = useState({});
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [invoiceData, setInvoiceData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [invoiceUrl, setInvoiceUrl] = useState(null);
  const [editVendor, setEditVendor] = useState(false);
  const [editCustomer, setEditCustomer] = useState(false);
  const [editPayment, setEditPayment] = useState(false);
  const [editTerms, setEditTerms] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isReminderModalOpen, setIsReminderModalOpen] = useState(false);
  const [isSavingReminder, setIsSavingReminder] = useState(false);
  const [reminderDate, setReminderDate] = useState(null);
  const formatReminderOption = (input) =>
    input.toLowerCase().replace(/\s+/g, "_"); // e.g. "1 day before" → "1_day_before"
  const parseReminderOption = (slug) =>
    slug.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

  const handleInputChange = (field, value) => {
    setEditedData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };
  const handleAskCopilotClick = () => {
    navigate(
      `/Invoices/Invoice_chat?invoiceKey=${invoiceKey}&invoiceUrl=${encodeURIComponent(
        invoiceUrl
      )}&cid=${invoicesId}`
    );
  };

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (editRef.current && !editRef.current.contains(event.target)) {
        if (activeEditField) {
          handleSaveOnBlur(activeEditField);
          setActiveEditField(null);
        }
      }
      if (notesRef.current && !notesRef.current.contains(event.target)) {
        if (isEditingNote) {
          saveNote();
          setIsEditingNote(false);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [activeEditField, editRef, isEditingNote, userNote]);

  const handleFieldEdit = (field) => {
    setActiveEditField(field);
  };

  const handleEdit = () => {
    if (edit === true) {
      setEdit(false);
    } else {
      setEdit(true);
    }
  };

  const handleSaveReminder = async () => {
    if (!selectedDate || !invoiceKey) {
      alert("Please select a date before saving reminder.");
      return;
    }
    const formattedTimeframe = formatReminderOption(selectedDate); // ✅ FIX

    setIsSavingReminder(true);

    try {
      const response = await api.post(`/api/v1/invoice/create-reminder/`, {
        invoice_key: invoiceKey,
        reminder_timeframe: formattedTimeframe,
        note: note,
      });

      if (response.status === 201 || response.status === 200) {
        await fetchInvoiceDetails();
        setIsReminderModalOpen(false);
      }
    } catch (err) {
      const errorText =
        err?.response?.data?.error ||
        err?.response?.data?.msg ||
        "Failed to save/update reminder";
      setIsReminderModalOpen(false);
      setErrorMessage(errorText);
      setShowErrorPopup(true);
    } finally {
      setIsSavingReminder(false);
    }
  };

  const formatReminderDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const userEmail = localStorage.getItem("email");

  const handleSaveOnBlur = async (field) => {
    if (!editedData[field]) {
      setActiveEditField(null);
      return;
    }

    try {
      const response = await api.post(
        `api/v1/invoice/edit-invoice-details/${invoiceKey}/`,
        {
          edited_data: { [field]: editedData[field] },
        }
      );

      if (response.status === 200) {
        setInvoiceData((prevData) => ({
          ...prevData,
          [field]: editedData[field],
        }));
      }
    } catch (error) {
      console.error(
        "Error saving field:",
        error.response?.data || error.message
      );
    } finally {
      setActiveEditField(null);
    }
  };
  const saveNote = async () => {
    setIsSaving(true);

    try {
      const response = await api.post(
        `api/v1/invoice/edit-invoice-details/${invoiceKey}/`,
        {
          note: userNote.trim(),
          edited_data: { dummyField: "non-empty" },
        }
      );

      if (response.status === 200) {
        const updatedNote = response.data.data.note;
        setInvoiceData((prev) => ({ ...prev, note: updatedNote }));
        setUserNote(updatedNote);
      }
    } catch (error) {
      console.error(
        "Error saving note:",
        error.response?.data || error.message
      );
      alert("Failed to save the note.");
    } finally {
      setIsSaving(false);
    }
  };
  const handleDeleteField = async (fieldName) => {
    if (!invoiceId) return;

    try {
      const response = await api.delete(
        `api/v1/invoice/delete-field/${invoicesId}/`,
        {
          data: { field: fieldName },
        }
      );
      if (response.status === 200) {
        await fetchCustomFields(); // refresh list
      }
    } catch (error) {
      console.error("Delete failed:", error.response?.data || error.message);
      alert("Failed to delete field.");
    } finally {
      setDeletingField(null); // ✅ reset the button
    }
  };

  const hasFetchedFields = useRef(false);
  useEffect(() => {
    if (isModalOpen && !hasFetchedFields.current) {
      fetchCustomFields();
      hasFetchedFields.current = true;
    }
    if (!isModalOpen) {
      hasFetchedFields.current = false; // Reset for next time
    }
  }, [isModalOpen]);

  useEffect(() => {
    if (isModalOpen && selectedTab === "manage" && !hasFetchedFields.current) {
      fetchCustomFields();
      hasFetchedFields.current = true;
    }
  }, [isModalOpen, selectedTab]);

  const handleAddField = async () => {
    if (!isFilled || !invoiceId) return;
    setLoadingAddField(true);

    try {
      const response = await api.post(
        `api/v1/invoice/create-field/${invoicesId}/`,
        {
          field: fieldName,
          description: fieldPrompt,
        }
      );

      if (response.status === 201) {
        setFieldName("");
        setFieldPrompt("");
        await fetchCustomFields(); // Refresh the list
        const response = await api.post(`api/v1/readpdf/extract-invoice/`, {
          pdf_key: invoiceKey,
        });
        if (response.status === 200) {
          const fetchedInvoiceData = response.data.invoice_data;
          setInvoiceData(fetchedInvoiceData);
          setInvoiceUrl(response.data.invoice_url);
          setEditedData(fetchedInvoiceData);
          setUserNote(fetchedInvoiceData?.note || "");
          setInvoicesId(response.data.invoice_id || "");
          setReminderDate(response.data.reminder_date || null);
        } else {
          setError(response.data.msg || "Failed to fetch invoice details");
        }

        setIsModalOpen(false); // Close modal after success
      }
    } catch (error) {
      alert(
        "Error creating field: " + (error.response?.data?.msg || error.message)
      );
    } finally {
      setLoadingAddField(false);
    }
  };

  const fetchCustomFields = async () => {
    setCustomFieldsLoading(true);
    try {
      const response = await api.get(
        `api/v1/invoice/list-field/${invoicesId}/`
      );
      if (response.status === 200) {
        setCustomFields(response.data.custom_fields || []);
      }
    } catch (error) {
      console.error("Error fetching custom fields:", error);
    } finally {
      setCustomFieldsLoading(false);
    }
  };

  const handleUpdateReminder = async () => {
    if (!selectedDate || !invoiceKey) {
      alert("Please choose a date.");
      return;
    }
    const formattedTimeframe = formatReminderOption(selectedDate); // ✅ FIX

    setIsSavingReminder(true);
    try {
      const response = await api.patch(`/api/v1/invoice/update-reminder/`, {
        invoice_key: invoiceKey, // ✅ Add this line
        reminder_timeframe: formattedTimeframe,
      });
      if (response.status === 200) {
        await fetchInvoiceDetails(); // refresh data
        setIsReminderModalOpen(false);
      }
    } catch (error) {
      console.error(
        "Error updating reminder:",
        error.response?.data || error.message
      );
      toast.error(error.response?.data?.error || "Failed to update reminder.");
    } finally {
      setIsSavingReminder(false);
    }
  };
  const [isDeletingReminder, setIsDeletingReminder] = useState(false);

  const handleDeleteReminder = async () => {
    if (!invoiceKey) return;

    setIsDeletingReminder(true);

    try {
      const response = await api.delete(
        `/api/v1/invoice/delete-reminder/${invoiceKey}/`
      );
      if (response.status === 200) {
        await fetchInvoiceDetails();
        setReminderDate(null);
        setIsReminderModalOpen(false);
      }
    } catch (error) {
      console.error(
        "Error deleting reminder:",
        error.response?.data || error.message
      );
      alert("Failed to delete reminder.");
    } finally {
      setIsDeletingReminder(false);
    }
  };

  const handleSaveCustomField = async (fieldKey) => {
    const updatedValue = editedData[fieldKey];
    try {
      const response = await api.post(
        `api/v1/invoice/edit-invoice-details/${invoiceKey}/`,
        {
          edited_data: { [fieldKey]: updatedValue },
        }
      );
      if (response.status === 200) {
        setInvoiceData((prevData) => ({
          ...prevData,
          _custom_fields: {
            ...prevData._custom_fields,
            [fieldKey]: updatedValue,
          },
        }));

        setEditingCustomField(null);
      }
    } catch (error) {
      setEditingCustomField(null);
    }
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  const fetchInvoiceDetails = async () => {
    try {
      const response = await api.post(`api/v1/readpdf/extract-invoice/`, {
        pdf_key: invoiceKey,
      });

      if (response.status === 200) {
        const fetchedInvoiceData = response.data.invoice_data;
        setInvoiceData(fetchedInvoiceData);
        setInvoiceUrl(response.data.invoice_url);
        setEditedData(fetchedInvoiceData);
        setUserNote(fetchedInvoiceData?.note || "");
        setInvoicesId(response.data.invoice_id || "");
        setReminderDate(response.data.reminder_date || null);
      } else {
        setError(response.data.msg || "Failed to fetch invoice details");
      }
    } catch (error) {
      console.error(
        "Error fetching invoice details:",
        error.response?.data || error.message
      );
      setError("An error occurred while fetching invoice details.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (invoiceKey) {
      fetchInvoiceDetails();
    }
  }, [invoiceKey]);

  if (loading) {
    return <p>Loading invoice details...</p>;
  }

  if (error) {
    return <p className="error">{error}</p>;
  }

  const toggleTerms = () => {
    setIsTermsOpen((prev) => !prev);
  };

  const toggleSection = (section) => {
    setOpenSections((prevSections) => ({
      ...prevSections,
      [section]: !prevSections[section],
    }));
  };

  const {
    "Invoice ID": invoiceId,
    "Invoice title": invoiceTitle,
    "Due date": dueDate,
    "Issued on": issuedOn,
    "Vendor name": vendorName,
    "Vendor address": vendorAddress,
    "Vendor email": vendorEmail,
    "Vendor telephone": vendorTelephone,
    "Customer name": customerName,
    "Customer address": customerAddress,
    "Customer telephone": customerTelephone,
    "Customer email": customerEmail,
    "Total due amount": totalAmount,
    "Payment status": paymentStatus,
    "Terms and conditions": termsAndConditions,
    "Line items": lineItems = Array.isArray(invoiceData?.["Line items"])
      ? invoiceData["Line items"]
      : [],
  } = invoiceData || {};

  const isMaxFieldsReached = customFields.length >= 3;
  return (
    <div
    className="full_Container"
    style={{
      backgroundColor: "var(--Background-main, #FEF9F7)",
      minHeight: "100vh",
    }}
  >
    {/* 
      Added Tailwind classes:
      - sticky: Makes the element sticky
      - top-0: Sticks it to the very top of the screen
      - z-50: Ensures it stays above the scrolling content
      - Added background color so scrolling text doesn't show through 
    */}
 <div 
        className="header-container sticky top-0 z-50 pb-2" 
        style={{ backgroundColor: "var(--Background-main, #FEF9F7)" }}
      >
        <Header
          icon="/arrow-back.svg"
          name="Go to Invoices"
          // askCoPiolt={true}
          invoiceKey={invoiceKey}
          invoicesId={invoicesId}
          invoiceUrl={invoiceUrl}
          onGoToInvoices={handleGoToInvoices}
        />
      </div>
      <div className="w-full mt-4 flex-grow px-2">
        <header className="header">
          <div
            className="header-content-invoices"
            style={{
              width: "100%",
            }}
          >
            <div className="contract-info">
              <img
                src="/hicon.svg"
                alt="icon"
                className="contract-icon-invoice"
              />
              <div>
                <h1 className="contract-title-invoice">
                  {invoiceTitle || "Invoice Details"}
                </h1>
                <p className="contract-type">
                  Issued On: <span>{issuedOn || "N/A"}</span>
                </p>
                <p className="contract-type flex mt-2">
                  <img
                    src="/due-red-dot.svg"
                    alt="Due Icon"
                    style={{
                      width: "16px",
                      height: "16px",
                      marginRight: "6px",
                      verticalAlign: "middle",
                    }}
                  />
                  Due On: <span>{invoiceData?.["Due in"] || "N/A"}</span>
                </p>
                <p className="flex button-icon-invoice">
                  <span className="pt-1">
                    <img src="/eye-invoice.svg" alt="" />
                  </span>
                  <span onClick={openPopup}>View Invoice</span>
                </p>
              </div>
            </div>
            <div className="invoice-buttons-wrapper">
              <div className="invoice-buttons-group">
                <button
                  className="view-contract-button-invoice"
                  onClick={handleAskCopilotClick}
                >
                  <img src="/ai-icon.svg" alt="AI Icon" className="h-4 w-4" />
                  <span>Ask Copilot</span>
                </button>
              </div>
            </div>
          </div>
        </header>
        {invoiceUrl && isPopupOpen && (
          <div className="contract-modal-overlay" onClick={closePopup}>
            <div
              className="contract-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button onClick={closePopup}></button>
              <iframe
                src={invoiceUrl}
                title="Invoice Document"
                className="contract-iframe"
              ></iframe>
            </div>
          </div>
        )}
        <h4 className="customer-header-invoice">
          {/* <span role="img" aria-label="icon">
            <img src="/custDetails.svg" alt="" />
          </span> */}
          Extracted Details
        </h4>
        <section
          className="customer-details-invoices"
          style={{
            width: "100%",
          }}
        >
          <div className="customer-cards">
            <div className="customer-card-invoice" ref={editRef}>
              <div className="flex items-center relative w-full gap-2">
                <span className="party-label">Vendor Information</span>
                {!editVendor && (
                  <img
                    src="/edit-icon.svg"
                    alt="Edit"
                    className="edit-icon cursor-pointer w-[20px] h-[20px] absolute right-[10px] top-1/2 transform -translate-y-1/2"
                    onClick={() => setEditVendor(true)}
                  />
                )}
              </div>

              <div className="signatory-invoice">
                <strong>Primary Contact:</strong>{" "}
                {editVendor ? (
                  <input
                    className="pt-1 w-[267px] h-[27px] rounded-lg border border-[rgba(0,0,0,0.1)] bg-[#FEF9F7] outline-none text-[15px] font-medium leading-normal text-[#73607B] pb-[8px] font-outfit"
                    type="text"
                    value={
                      editedData["Vendor name"] !== undefined
                        ? editedData["Vendor name"]
                        : vendorName || ""
                    }
                    onChange={(e) =>
                      handleInputChange("Vendor name", e.target.value)
                    }
                    onBlur={() => {
                      handleSaveOnBlur("Vendor name");
                      setEditVendor(false);
                    }}
                  />
                ) : (
                  <span className="cust-details-invoice">
                    {vendorName || "N/A"}
                  </span>
                )}
              </div>

              <p
                className="signatory-invoice"
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                }}
              >
                <strong
                  style={{
                    width: "60px", // Fixed width ensures label alignment
                    textAlign: "left", // Ensures text remains aligned properly
                  }}
                >
                  Address:
                </strong>{" "}
                {editVendor ? (
                  <textarea
                    style={{ marginLeft: "3.45rem" }}
                    className="pl-4 w-[312px] h-[65px] rounded-lg border border-[rgba(0,0,0,0.1)] bg-[#FEF9F7] outline-none text-[15px] font-medium leading-normal text-[#73607B]  font-outfit whitespace-normal break-words"
                    type="text"
                    value={
                      editedData["Vendor address"] !== undefined
                        ? editedData["Vendor address"]
                        : vendorAddress || ""
                    }
                    onChange={(e) =>
                      handleInputChange("Vendor address", e.target.value)
                    }
                    onBlur={() => {
                      handleSaveOnBlur("Vendor address");
                      setEditVendor(false);
                    }}
                  />
                ) : (
                  <span
                    className="cust-details"
                    style={{
                      marginLeft: "78px",
                      marginTop: "1px",
                      flex: "1",
                      display: "inline-block",
                      wordBreak: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    {vendorAddress || "N/A"}
                  </span>
                )}
              </p>

              <div className="signatory-invoice">
                <strong>Phone Number:</strong>{" "}
                {editVendor ? (
                  <input
                    className="ml-2 pt-2 w-[267px] h-[27px] rounded-lg border border-[rgba(0,0,0,0.1)] bg-[#FEF9F7] outline-none text-[15px] font-medium leading-normal text-[#73607B] pb-[10px] font-outfit"
                    type="text"
                    value={
                      editedData["Vendor telephone"] !== undefined
                        ? editedData["Vendor telephone"]
                        : vendorTelephone || ""
                    }
                    onChange={(e) =>
                      handleInputChange("Vendor telephone", e.target.value)
                    }
                    onBlur={() => {
                      handleSaveOnBlur("Vendor telephone");
                      setEditVendor(false);
                    }}
                  />
                ) : (
                  <span
                    className="phone-data"
                    style={{
                      marginLeft: "30px",
                      display: "inline-block",
                      marginTop: "-17px",
                    }}
                  >
                    {vendorTelephone || "N/A"}
                  </span>
                )}
              </div>

              <div className="signatory-invoice">
                <strong>Email Address:</strong>{" "}
                {editVendor ? (
                  <input
                    className="ml-4 pt-1 w-[267px] h-[27px] rounded-lg border border-[rgba(0,0,0,0.1)] bg-[#FEF9F7] outline-none text-[15px] font-medium leading-normal text-[#73607B] pb-[10px] font-outfit"
                    type="text"
                    value={
                      editedData["Vendor email"] !== undefined
                        ? editedData["Vendor email"]
                        : vendorEmail || ""
                    }
                    onChange={(e) =>
                      handleInputChange("Vendor email", e.target.value)
                    }
                    onBlur={() => {
                      handleSaveOnBlur("Vendor email");
                      setEditVendor(false);
                    }}
                  />
                ) : (
                  <span
                    className="email-data"
                    style={{
                      marginLeft: "40px",
                      display: "inline-block",
                      marginTop: "-17px",
                    }}
                  >
                    {vendorEmail || "N/A"}
                  </span>
                )}
              </div>
            </div>
            <div className="w-[2px] h-[178px] bg-[rgba(0,0,0,0.10)] mt-4"></div>

            <div className="customer-card-invoice">
              <div className="flex items-center relative w-full gap-2">
                <span className="party-label">Customer Information</span>
                {!edit && (
                  <img
                    src="/edit-icon.svg"
                    alt="Edit"
                    className="edit-icon cursor-pointer w-[20px] h-[20px] absolute right-[10px] top-1/2 transform -translate-y-1/2"
                    onClick={() => setEditCustomer(true)}
                  />
                )}
              </div>

              <p className="signatory-invoice">
                <strong>Primary Contact:</strong>{" "}
                {editCustomer ? (
                  <input
                    className="w-[267px] h-[27px] rounded-lg border border-[rgba(0,0,0,0.1)] bg-[#FEF9F7] outline-none text-[15px] font-medium leading-normal text-[#73607B] pb-[8px] font-outfit"
                    type="text"
                    value={
                      editedData["Customer name"] !== undefined
                        ? editedData["Customer name"]
                        : customerName || ""
                    }
                    onChange={(e) =>
                      handleInputChange("Customer name", e.target.value)
                    }
                    onBlur={() => {
                      handleSaveOnBlur("Customer name");
                      setEditCustomer(false);
                    }}
                  />
                ) : (
                  <span className="cust-details-invoice">
                    {customerName || "N/A"}
                  </span>
                )}
              </p>

              <p
                className="signatory-invoice"
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                }}
              >
                <strong
                  style={{
                    width: "60px",
                    textAlign: "left",
                  }}
                >
                  Address:
                </strong>{" "}
                {editCustomer ? (
                  <textarea
                    style={{ marginLeft: "3.45rem" }}
                    className="pl-4 w-[312px] h-[65px] rounded-lg border border-[rgba(0,0,0,0.1)] bg-[#FEF9F7] outline-none text-[15px] font-medium leading-normal text-[#73607B]  font-outfit whitespace-normal break-words"
                    type="text"
                    value={
                      editedData["Customer address"] !== undefined
                        ? editedData["Customer address"]
                        : customerAddress || ""
                    }
                    onChange={(e) =>
                      handleInputChange("Customer address", e.target.value)
                    }
                    onBlur={() => {
                      handleSaveOnBlur("Customer address");
                      setEditCustomer(false);
                    }}
                  />
                ) : (
                  <span
                    className="cust-details"
                    style={{
                      marginLeft: "77px",
                      marginTop: "1px",
                      flex: "1",
                      display: "inline-block",
                      wordBreak: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    {customerAddress || "N/A"}
                  </span>
                )}
              </p>

              <div className="signatory-invoice">
                <strong>Phone Number:</strong>{" "}
                {editCustomer ? (
                  <input
                    className="ml-2 pt-2 w-[267px] h-[27px] rounded-lg border border-[rgba(0,0,0,0.1)] bg-[#FEF9F7] outline-none text-[15px] font-medium leading-normal text-[#73607B] pb-[10px] font-outfit"
                    type="text"
                    value={
                      editedData["Customer telephone"] !== undefined
                        ? editedData["Customer telephone"]
                        : customerTelephone || ""
                    }
                    onChange={(e) =>
                      handleInputChange("Customer telephone", e.target.value)
                    }
                    onBlur={() => {
                      handleSaveOnBlur("Customer telephone");
                      setEditCustomer(false);
                    }}
                  />
                ) : (
                  <span
                    className="phone-data"
                    style={{
                      marginLeft: "30px",
                      display: "inline-block",
                      marginTop: "-17px",
                    }}
                  >
                    {customerTelephone || "N/A"}
                  </span>
                )}
              </div>

              <div className="signatory-invoice">
                <strong>Email Address:</strong>{" "}
                {editCustomer ? (
                  <input
                    className="ml-4 pt-1 w-[267px] h-[27px] rounded-lg border border-[rgba(0,0,0,0.1)] bg-[#FEF9F7] outline-none text-[15px] font-medium leading-normal text-[#73607B] pb-[10px] font-outfit"
                    type="text"
                    value={
                      editedData["Customer email"] !== undefined
                        ? editedData["Customer email"]
                        : customerEmail || ""
                    }
                    onChange={(e) =>
                      handleInputChange("Customer email", e.target.value)
                    }
                    onBlur={() => {
                      handleSaveOnBlur("Customer email");
                      setEditCustomer(false);
                    }}
                  />
                ) : (
                  <span
                    className="email-data"
                    style={{
                      marginLeft: "40px",
                      display: "inline-block",
                      marginTop: "-17px",
                    }}
                  >
                    {customerEmail !== "null" ? customerEmail : "N/A"}
                  </span>
                )}
              </div>
            </div>
          </div>
        </section>

        {invoiceData &&
          invoiceData._custom_fields &&
          Object.keys(invoiceData._custom_fields).length > 0 && (
            <>
              <div className="flex flex-col space-y-4 mt-2">
                {Object.entries(invoiceData._custom_fields).map(
                  ([key, value]) =>
                    value || value !== "null" ? (
                      <div
                        className="accordion-item-invoicees  mt-4"
                        key={key}
                        style={{
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginLeft: "30px",
                              marginTop: "10px",
                            }}
                          >
                            <h3 className="payment-info-title-invoice">
                              {key}
                            </h3>
                            <img
                              src="/invoice-bulblogo-invoicee.svg"
                              alt="Bullet Icon"
                              className=" ml-2"
                            />
                          </div>
                          <img
                            src="/edit-icon.svg"
                            alt="Edit"
                            style={{
                              cursor: "pointer",
                              width: "26px",
                              height: "26px",
                              marginRight: "10px",
                              marginTop: "10px",
                            }}
                            onClick={() => setEditingCustomField(key)}
                          />
                        </div>

                        <div className="ml-8" style={{ borderBottom: "10x" }}>
                          {editingCustomField === key ? (
                            <textarea
                              className="w-[95%] h-[100px] rounded-lg border border-gray-300 bg-[#FEF9F7] p-2 outline-none text-sm text-gray-800"
                              value={
                                editedData[key] !== undefined
                                  ? editedData[key]
                                  : value
                              }
                              onChange={(e) =>
                                handleInputChange(key, e.target.value)
                              }
                              onBlur={() => handleSaveCustomField(key)}
                              autoFocus
                            />
                          ) : (
                            <div className="max-h-[300px] overflow-y-auto">
                              {(() => {
                                let parsedValue = null;
                                try {
                                  parsedValue =
                                    typeof value === "string"
                                      ? JSON.parse(value)
                                      : value;
                                } catch {
                                  parsedValue = null;
                                }

                                // ✅ Case 0: Array of objects (like line items)
                                if (
                                  Array.isArray(parsedValue) &&
                                  parsedValue.length > 0 &&
                                  typeof parsedValue[0] === "object" &&
                                  !Array.isArray(parsedValue[0])
                                ) {
                                  const headers = Array.from(
                                    new Set(
                                      parsedValue.flatMap((obj) =>
                                        Object.keys(obj)
                                      )
                                    )
                                  );

                                  return (
                                    <table className="w-[95%] mt-2 border border-gray-200 text-sm mb-2">
                                      <thead>
                                        <tr>
                                          {headers.map((h, i) => (
                                            <th
                                              key={i}
                                              className="border border-gray-300 px-3 py-2 bg-gray-100 text-left whitespace-pre-wrap"
                                            >
                                              {h}
                                            </th>
                                          ))}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {parsedValue.map((rowObj, rowIndex) => (
                                          <tr key={rowIndex}>
                                            {headers.map((h, j) => (
                                              <td
                                                key={j}
                                                className="border border-gray-300 px-3 py-2 whitespace-pre-wrap"
                                              >
                                                {rowObj[h] ?? "—"}
                                              </td>
                                            ))}
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  );
                                }

                                // ✅ Case 2: Markdown table
                                if (
                                  typeof value === "string" &&
                                  value.includes("|") &&
                                  value.split("\n").length > 2
                                ) {
                                  const lines = value
                                    .trim()
                                    .split("\n")
                                    .filter(Boolean);
                                  const headers = lines[0]
                                    .split("|")
                                    .map((h) => h.trim())
                                    .filter(Boolean);
                                  const rows = lines.slice(2).map((line) =>
                                    line
                                      .split("|")
                                      .map((cell) => cell.trim())
                                      .filter(Boolean)
                                  );

                                  return (
                                    <table className="w-[95%] mt-2 border border-gray-200 text-sm mb-2">
                                      <thead>
                                        <tr>
                                          {headers.map((h, i) => (
                                            <th
                                              key={i}
                                              className="border border-gray-300 px-3 py-2 bg-gray-100 text-left whitespace-pre-wrap"
                                            >
                                              {h}
                                            </th>
                                          ))}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {rows.map((row, i) => (
                                          <tr key={i}>
                                            {row.map((cell, j) => (
                                              <td
                                                key={j}
                                                className="border border-gray-300 px-3 py-2 whitespace-pre-wrap"
                                              >
                                                {cell}
                                              </td>
                                            ))}
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  );
                                }

                                // ✅ Case 3: Mixed paragraph + key: value block
                                if (typeof value === "string") {
                                  const lines = value.split("\n");
                                  const groups = [];
                                  let currentParagraph = [];
                                  let currentTable = [];

                                  const flushGroup = () => {
                                    if (
                                      currentParagraph.length ||
                                      currentTable.length
                                    ) {
                                      groups.push({
                                        paragraph: currentParagraph,
                                        table: currentTable,
                                      });
                                      currentParagraph = [];
                                      currentTable = [];
                                    }
                                  };

                                  lines.forEach((line) => {
                                    if (!line.trim()) return;
                                    const colonIndex = line.indexOf(":");
                                    const key = line
                                      .slice(0, colonIndex)
                                      .trim();
                                    const val = line
                                      .slice(colonIndex + 1)
                                      .trim();

                                    if (
                                      colonIndex > 0 &&
                                      key.length < 50 &&
                                      line.length < 150 &&
                                      val
                                    ) {
                                      currentTable.push([key, val]);
                                    } else {
                                      flushGroup();
                                      currentParagraph.push(line);
                                    }
                                  });

                                  flushGroup();

                                  return (
                                    <div className="w-[96%] whitespace-pre-wrap break-words text-[#18101C] font-[Outfit] text-[16px] font-medium leading-[23px] tracking-[0.16px] mt-1">
                                      {groups.map((group, index) => (
                                        <div key={index} className="mb-3">
                                          {group.paragraph.map((line, i) => (
                                            <p key={i} className="mb-1">
                                              {line}
                                            </p>
                                          ))}

                                          {group.table.length > 0 && (
                                            <table className="w-[95%] mt-2 border border-gray-200 text-sm">
                                              <thead>
                                                <tr>
                                                  <th className="border border-gray-300 px-3 py-2 bg-gray-100 text-left">
                                                    Field
                                                  </th>
                                                  <th className="border border-gray-300 px-3 py-2 bg-gray-100 text-left">
                                                    Value
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {group.table.map(
                                                  ([k, v], i) => (
                                                    <tr key={i}>
                                                      <td className="border border-gray-300 px-3 py-2 font-semibold w-1/3">
                                                        {k}
                                                      </td>
                                                      <td className="border border-gray-300 px-3 py-2">
                                                        {v}
                                                      </td>
                                                    </tr>
                                                  )
                                                )}
                                              </tbody>
                                            </table>
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  );
                                }

                                // ✅ Fallback
                                return (
                                  <p className="w-[96%] whitespace-pre-wrap break-words text-[#18101C] font-[Outfit] text-[16px] font-medium leading-[23px] tracking-[0.16px] mt-1">
                                    {typeof value === "object"
                                      ? JSON.stringify(value, null, 2)
                                      : String(value || "")}
                                  </p>
                                );
                              })()}
                            </div>
                          )}
                        </div>
                      </div>
                    ) : null
                )}
              </div>
            </>
          )}
        <section className="key-dates-wrapper" ref={editRef}>
          <div
            className="key-dates-invoices"
            style={{
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "30px",
                }}
              >
                {/* <img src="/invoice-paylogo.svg" alt="Key Dates Icon" /> */}
                <h3 className="payment-info-title-invoice">
                  Payment Information
                </h3>
                <img
                  src="/invoice-bulblogo-invoice.svg"
                  alt="Key Dates Icon"
                  className="ml-2"
                />
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                {!edit && (
                  <img
                    src="/edit-icon.svg"
                    alt="Edit"
                    style={{
                      cursor: "pointer",
                      width: "26px",
                      height: "26px",
                      marginRight: "10px",
                    }}
                    onClick={(e) => {
                      e.stopPropagation(); // Stop bubbling to parent toggle
                      setEditPayment(true);
                    }}
                  />
                )}
                {/* <img
                  src={isKeyDatesOpen ? "/up-arrow.svg" : "/down-arrow.svg"}
                  alt="Toggle Dropdown"
                  style={{
                    cursor: "pointer",
                    width: "20px",
                    height: "20px",
                  }}
                  // onClick={() => setIsKeyDatesOpen((prev) => !prev)}
                /> */}
              </div>
            </div>

            <div
              className="date-details-invoice"
              style={{ borderBottom: "none" }}
            >
              <div className="effective gap-3">
                <img src="/edit-icon-firsts.svg" alt="Edit" />
                <p className=""> Total Due: </p>
                <p>
                  {editPayment ? (
                    <input
                      className="unique-input "
                      type="text"
                      value={
                        editedData["Total due amount"] !== undefined
                          ? editedData["Total due amount"]
                          : totalAmount || ""
                      }
                      onChange={(e) =>
                        handleInputChange("Total due amount", e.target.value)
                      }
                      onBlur={() => {
                        handleSaveOnBlur("Total due amount");
                        setEditPayment(false);
                      }}
                    />
                  ) : (
                    <span className="" style={{ color: "#8B55DD" }}>
                      {totalAmount || "N/A"}
                    </span>
                  )}
                </p>
              </div>
              <div className="effective gap-3">
                <img src="/edit-icon-seconds.svg" alt="Edit" />
                <p>Payment Status: </p>
                <p>
                  {editPayment ? (
                    <select
                      className="w-[150px] h-[30px] border border-gray-300 rounded bg-[#FEF9F7] text-[13px] font-medium outline-none"
                      value={
                        editedData["Payment status"] !== undefined
                          ? editedData["Payment status"]
                          : paymentStatus || ""
                      }
                      onChange={(e) =>
                        handleInputChange("Payment status", e.target.value)
                      }
                      onBlur={() => {
                        handleSaveOnBlur("Payment status");
                        setEditPayment(false);
                      }}
                    >
                      <option value="Paid" className="text-[#28D9AA]">
                        Paid
                      </option>
                      <option value="Pending" className="text-[#BFD70D]">
                        Pending
                      </option>
                      <option
                        value="Overdue"
                        className="text-[rgba(226,25,25,0.80)]"
                      >
                        Overdue
                      </option>
                    </select>
                  ) : (
                    <span
                      className={`${
                        paymentStatus === "Paid"
                          ? "text-[#28D9AA]"
                          : paymentStatus === "Pending"
                          ? "text-[#BFD70D]"
                          : paymentStatus === "Overdue"
                          ? "text-[rgba(226,25,25,0.80)]"
                          : "text-gray-700"
                      }`}
                    >
                      <span className="">{paymentStatus || "N/A"}</span>
                    </span>
                  )}
                </p>
              </div>
              <div className="effective gap-3">
                <img src="/edit-icon-seconds.svg" alt="Edit" />
                <p>Due in: </p>
                <p>
                  {editPayment ? (
                    <input
                      className="unique-input"
                      type="text"
                      value={
                        editedData["Due in"] !== undefined
                          ? editedData["Due in"]
                          : "N/A"
                      }
                      onChange={(e) =>
                        handleInputChange("Due in", e.target.value)
                      }
                      onBlur={() => {
                        handleSaveOnBlur("Due in");
                        setEditPayment(false);
                      }}
                    />
                  ) : (
                    <span className="keyValue">
                      {invoiceData?.["Due in"] || "N/A"}
                    </span>
                  )}
                </p>
              </div>
            </div>

            <div class=" ml-[30px] flex w-[94.4%] h-[72px] px-[16px] py-[12px] justify-between items-center gap-[346px] rounded-[6px] border border-[#F3904F] bg-[rgba(139,85,221,0.16)]">
              <div class="">
                <div class="text-[#1A1A1A] flex gap-2">
                  <img
                    src={
                      reminderDate
                        ? "/not-alert-circlesss.svg"
                        : "/not-alert-circle.svg"
                    }
                    alt="icon"
                    className="w-5 h-5"
                  />
                  <p className="payment-design-remin">
                    {reminderDate
                      ? `Reminder set for ${formatReminderDate(
                          reminderDate
                        )}(before the due date)`
                      : "Payment Reminder"}
                  </p>{" "}
                </div>
                <p class="payment-design-remin-desc">
                  {" "}
                  {reminderDate
                    ? `You’ll receive a reminder at ${
                        userEmail || "your email"
                      }.`
                    : "Never miss a payment—add a reminder before the due date."}
                </p>
              </div>
              <div className="flex gap-2">
                <button
                  className={`set-remin-new ${
                    reminderDate ? "has-reminder" : ""
                  }`}
                  onClick={() => {
                    setSelectedDate(
                      reminderDate ? parseReminderOption(reminderDate) : ""
                    );
                    setIsReminderModalOpen(true);
                  }}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                >
                  {reminderDate ? "Edit Reminder" : "Set Reminder"}
                  <img
                    src={
                      isHovered
                        ? "/white-colour-fixed-noti.svg" // icon only on hover
                        : reminderDate
                        ? "/edit-iconss.svg"
                        : "/not-alert-circles.svg"
                    }
                    alt="icon"
                    className="w-5 h-5"
                  />
                </button>
              </div>
            </div>
          </div>
        </section>
        <section
          className="mt-3 line-tems-box-size"
          style={{
            width: "100%",
          }}
        >
          <LineItems
            invoiceKey={invoiceKey}
            initialLineItems={invoiceData?.["Line items"]}
            updateLineItems={(updatedLineItems) =>
              setInvoiceData((prevData) => ({
                ...prevData,
                "Line items": updatedLineItems,
              }))
            }
          />
        </section>
        <section
          className="mt-3"
          style={{
            width: "100%",
          }}
        >
          <div className="accordion-item-invoice">
            <div
              className="accordion-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              onClick={() => setIsTermsOpen(!isTermsOpen)}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <p className="Terms-condition-title ml-6">
                  Terms and Conditions
                </p>
                <img
                  src="/invoice-bulblogo-invoice.svg"
                  alt="Key Dates Icon"
                  className="ml-2"
                />
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                {isTermsOpen && !editTerms && (
                  <img
                    src="/edit-icon.svg"
                    alt="Edit"
                    style={{
                      cursor: "pointer",
                      width: "20px",
                      height: "20px",
                    }}
                    onClick={(e) => {
                      e.stopPropagation(); // ✅ Prevents parent onClick
                      setEditTerms(true);
                    }}
                  />
                )}
                <img
                  src={isTermsOpen ? "/up-arrow.svg" : "/down-arrow.svg"}
                  alt={isTermsOpen ? "Collapse" : "Expand"}
                  style={{
                    cursor: "pointer",
                    width: "20px",
                    height: "20px",
                  }}
                />
              </div>
            </div>
            {isTermsOpen && (
              <div
                className="accordion-content"
                style={{
                  padding: "1px",
                  marginLeft: "20px",
                  color: "var(--Text-h1, #18101C)",
                  fontFamily: "Outfit",
                  fontSize: "16px",
                  fontStyle: "normal",
                }}
              >
                {editTerms ? (
                  <textarea
                    className="w-full h-[150px] rounded-lg border border-gray-300 bg-[#FEF9F7] p-2 outline-none text-sm text-gray-800"
                    value={
                      editedData["Terms and conditions"] !== undefined
                        ? editedData["Terms and conditions"]
                        : termsAndConditions || ""
                    }
                    onChange={(e) =>
                      handleInputChange("Terms and conditions", e.target.value)
                    }
                    onBlur={() => {
                      handleSaveOnBlur("Terms and conditions");
                      setEditTerms(false);
                    }}
                  />
                ) : (
                  (() => {
                    let parsedValue = null;
                    try {
                      parsedValue =
                        typeof termsAndConditions === "string"
                          ? JSON.parse(termsAndConditions)
                          : termsAndConditions;
                    } catch {
                      parsedValue = null;
                    }

                    if (
                      parsedValue &&
                      typeof parsedValue === "object" &&
                      !Array.isArray(parsedValue)
                    ) {
                      return (
                        <table className="w-[95%] mt-2 border border-gray-200 text-sm mb-2">
                          <tbody>
                            {Object.entries(parsedValue).map(([k, v], i) => (
                              <tr key={i}>
                                <td className="border border-gray-300 px-3 py-2 font-semibold align-top w-1/3 whitespace-pre-wrap text-[#18101C] font-[Outfit] text-[15px]">
                                  {k}
                                </td>
                                <td className="border border-gray-300 px-3 py-2 whitespace-pre-wrap text-[#18101C] font-[Outfit] text-[15px]">
                                  {String(v ?? "N/A")}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      );
                    }

                    return (
                      <p className="whitespace-pre-wrap text-[#18101C] font-[Outfit] text-[16px] leading-[23px]">
                        {termsAndConditions ||
                          "No terms and conditions available."}
                      </p>
                    );
                  })()
                )}
              </div>
            )}
          </div>
        </section>
        <section className="notes-sections">
          <div className="notes-items" ref={notesRef}>
            <div
              className="notes-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <p className="notes" style={{ margin: 0 }}>
                <span>
                  <img src="/notes.svg" alt="" />
                </span>{" "}
                Notes
              </p>
            </div>
            <div style={{ position: "relative", width: "100%" }}>
              <textarea
                placeholder="Enter your comments here..."
                className="notes-input custom-placeholder-invoice"
                style={{
                  width: "100%",
                }}
                value={userNote}
                onChange={(e) => setUserNote(e.target.value)}
                onFocus={() => setIsEditingNote(true)}
              />
            </div>
            {isSaving && (
              <p style={{ fontSize: "12px", color: "green", marginTop: "5px" }}>
                Saving...
              </p>
            )}
          </div>
        </section>
      </div>
      {isModalOpen && (
        <div className="custom-modal-overlay-inline show">
          <div className="custom-modal-content-custom active">
            <button
              className="close-modal-custom"
              onClick={() => setIsModalOpen(false)}
            >
              ×
            </button>

            <h2 className="custom-modal-title-custom">Custom Fields</h2>
            <p className="custom-modal-subtitle-custom">
              You can only create up to 3 custom fields per document.
              <br />
              Deleting a field won’t reset the limit.
            </p>

            <div className="custom-modal-tabs-custom">
              <button
                className={`manage-btn-custom ${
                  selectedTab === "manage" ? "active" : ""
                }`}
                onClick={() => setSelectedTab("manage")}
              >
                {customFieldsLoading
                  ? "Loading..."
                  : `Manage Existing Fields (${customFields.length}/3)`}
              </button>

              <button
                className={`create-btn-custom ${
                  selectedTab === "create" ? "active" : ""
                }`}
                onClick={() => setSelectedTab("create")}
              >
                Create New Field
              </button>
            </div>

            {selectedTab === "create" && (
              <>
                <label className="field-label-custom">
                  Field name{" "}
                  <img
                    src="/bulb.svg"
                    alt="Hint"
                    className="label-icon-custom"
                  />
                </label>
                <input
                  type="text"
                  className="input-field-custom"
                  value={fieldName}
                  onChange={(e) => setFieldName(e.target.value)}
                  placeholder={
                    isMaxFieldsReached
                      ? "Maximum 3 fields allowed. Please delete one to add new."
                      : "Enter your field name here"
                  }
                  disabled={isMaxFieldsReached}
                />

                <label className="field-label-custom">
                  Extraction Prompt{" "}
                  <img
                    src="/bulb.svg"
                    alt="Hint"
                    className="label-icon-custom"
                  />
                </label>
                <textarea
                  className="textarea-field-custom"
                  value={fieldPrompt}
                  onChange={(e) => setFieldPrompt(e.target.value)}
                  placeholder={
                    isMaxFieldsReached
                      ? "Cannot enter prompt. Maximum limit reached."
                      : "Enter your Extraction Prompts here"
                  }
                  disabled={isMaxFieldsReached}
                />

                <button
                  className={`add-field-btn-custom ${
                    isFilled && !loadingAddField && !isMaxFieldsReached
                      ? "active"
                      : ""
                  }`}
                  onClick={handleAddField}
                  disabled={loadingAddField || isMaxFieldsReached}
                >
                  {loadingAddField ? "Adding..." : "Add Field"}
                </button>
              </>
            )}

            {selectedTab === "manage" && (
              <div>
                <div className="manage-fields-placeholder mt-[20px] max-h-[222px] overflow-y-auto mr-2">
                  <div className="flex mt-2 gap-[60px]">
                    <h2 className="field-name-custom">Field Name</h2>
                    <h2 className="field-name-custom">Prompt</h2>
                  </div>

                  {Array.isArray(customFields) && customFields.length > 0 ? (
                    customFields.map((field, index) => (
                      <div key={index}>
                        <div className="flex items-start gap-[26px] mt-[12px]">
                          <p className="text-[#1A1A1A] text-sm font-medium w-[109px] whitespace-nowrap">
                            {field.field}
                          </p>
                          <p className="text-[#1A1A1A] text-sm w-[139px]">
                            {field.description}
                          </p>
                          <button
                            className="button-red-custom-field"
                            onClick={() => {
                              setDeletingField(field.field); // disable this button
                              handleDeleteField(field.field);
                            }}
                            disabled={deletingField === field.field}
                          >
                            {deletingField === field.field
                              ? "Deleting"
                              : "Delete"}
                            <img
                              src="/delete-icon-red.svg"
                              alt="Delete"
                              className="delete-lineitems"
                            />
                          </button>
                        </div>
                        <div className="my-4 mt-[20px] border-[#EAEAEA] hr-line-divider"></div>
                      </div>
                    ))
                  ) : (
                    <p className="text-sm text-gray-500 ml-2 mt-3">
                      No custom fields available.
                    </p>
                  )}
                </div>

                <div>
                  <button
                    className={`add-field-btn-custom-two ${
                      isFilled ? "active" : ""
                    }`}
                    onClick={async () => {
                      await fetchInvoiceDetails(); // re-fetch latest data
                      setIsModalOpen(false); // then close modal
                    }}
                  >
                    Done
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {isReminderModalOpen && (
        <div className="reminder-overlay">
          <div className="reminder-modal">
            <button
              className="close-reminder"
              onClick={() => setIsReminderModalOpen(false)}
            >
              ×
            </button>

            <h2 className="reminder-title">Schedule a Payment Reminder</h2>
            <p className="reminder-desc">
              Pick a reminder date and email for this invoice.
            </p>

            <div className="reminder-form mt-[20px]">
              <div className="flex">
                <label className="remind-me-rem mt-2">Remind Me On</label>
                <div className="">
                  <ReminderDropdown
                    selected={selectedDate}
                    onChange={(value) => setSelectedDate(value)}
                  />
                </div>
              </div>
              {/* <label>Send Reminder To</label>
        <input type="email" className="reminder-input" value={customerEmail || ""} />

        <label>Repeat Reminder</label>
        <select className="reminder-input">
          <option>Don’t repeat</option>
          <option>Daily</option>
          <option>Weekly</option>
          <option>Monthly</option>
        </select> */}
              <div className="flex mt-4">
                <label className="note-reminder">
                  Note <span className="optional-rem pt-2">(optional)</span>
                </label>
                <textarea
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                  className="reminder-textarea ml-2 pl-3 pt-1"
                  placeholder="Add a note for this reminder (optional)"
                />
              </div>
              <div className="reminder-buttons">
                {!reminderDate && (
                  <button
                    className="cancel-reminder"
                    onClick={() => setIsReminderModalOpen(false)}
                  >
                    Cancel
                  </button>
                )}

                {!reminderDate && (
                  <button
                    className="save-reminder mb-2"
                    onClick={handleSaveReminder}
                    disabled={isSavingReminder}
                  >
                    {isSavingReminder ? "Saving..." : "Save Reminder"}
                  </button>
                )}

                {/* {reminderDate && (
  <button
    className="delete-reminders"
    onClick={handleDeleteReminder}
    disabled={isDeletingReminder}
  >
    {isDeletingReminder ? "Deleting..." : "Delete Reminder"}
  </button>
)} */}

                {reminderDate && (
                  <div className="flex">
                    <button
                      className="delete-reminderss"
                      onClick={handleDeleteReminder}
                      disabled={isDeletingReminder}
                    >
                      {isDeletingReminder ? "Deleting..." : "Delete"}
                    </button>
                    <button
                      className="save-reminderss ml-2 mb-2"
                      onClick={handleUpdateReminder}
                      disabled={isSavingReminder}
                    >
                      {isSavingReminder ? "Saving..." : "Update"}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {showErrorPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="design-for-alerts">
            <img
              src="/alert-icon.svg"
              alt="Alert logo"
              className="alert-icon-design"
            />
            <h2 className="alerts-heading mt-2">Can’t Complete Request</h2>
            <p className="alerts-heading-response">{errorMessage}</p>
            <button
              onClick={() => setShowErrorPopup(false)}
              className="alerts-button-okay"
            >
              Okay
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Invoice_Details;
